import axios from "axios";

export const fetchGetCompany = (companyId: string) => {
    return axios.get(`/api/company/${companyId}`);
};